module.exports = __webpack_public_path__ + "img/sewarna.e6e3eb5b.jpeg";